import { Helmet } from 'react-helmet';

export const SCode = () => {
  return (
    <Helmet>
      <script src="https://a0.awsstatic.com/s_code/js/3.0/awshome_s_code.js" type="text/javascript"></script>
    </Helmet>
  );
};
